<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-wrapper">
      <mat-icon>cancel</mat-icon>
      <div>
        {{ "kopetro.reviewApplication.rejectApplication" | translate }}
      </div>
    </div>
    <mat-icon class="icon-close" (click)="onClose()">close</mat-icon>
  </div>

  <mat-divider></mat-divider>

  <div class="mb-3">
    {{ "kopetro.reviewApplication.rejectDesc1" | translate }}
  </div>
  <div>{{ "kopetro.reviewApplication.rejectDesc2" | translate }}</div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="reject-container">
      <div class="form-wrapper">
        <mat-form-field>
          <mat-label>{{
            "kopetro.reviewApplication.rejectType" | translate
          }}</mat-label>
          <mat-select required formControlName="rejectType">
            <mat-option *ngFor="let item of rejectTypeList" [value]="item">{{
              item
            }}</mat-option>
          </mat-select>
          <mat-error
            >{{ "kopetro.reviewApplication.rejectType" | translate }} adalah
            wajib</mat-error
          >
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "kopetro.reviewApplication.rejectReason" | translate
          }}</mat-label>
          <mat-select required formControlName="rejectReason">
            <mat-option *ngFor="let item of rejectReasonList" [value]="item">{{
              item
            }}</mat-option>
          </mat-select>
          <mat-error
            >{{ "kopetro.reviewApplication.rejectReason" | translate }} adalah
            wajib</mat-error
          >
        </mat-form-field>

        <mat-form-field *ngIf="form.get('rejectReason').value === 'Lain-lain'">
          <mat-label>{{
            "kopetro.reviewApplication.remarks" | translate
          }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="6"
            formControlName="remarks"
          ></textarea>
          <mat-error *ngIf="form.get('remarks').errors?.required"
            >{{ "kopetro.reviewApplication.remarks" | translate }} adalah
            wajib</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <button mat-stroked-button type="submit" class="reject-btn">
      {{ "common.submit" | translate }}
    </button>
  </form>
</div>
